<div *ngIf="subscription$ | async as subscription" class="success a-fx-col a-fx-gap-32">
    <div class="h3">
        {{ 'settings.customer-subscription.thank-you' | translate }}
    </div>

    <p
        [innerHTML]="
            'settings.customer-subscription.thank-you-message'
                | translate
                    : {
                          startDate: subscription.startDate | formatDate: 'dd MMM, yyyy',
                          invoiceDate: subscription.nextInvoiceDate | formatDate: 'dd MMM, yyyy',
                      }
        "
    ></p>

    <div
        *ngIf="'settings.customer-subscription.stripe-message' | translate as message"
        class="a-bg-color-active success-info a-fx a-fx-gap-16"
    >
        <svg class="adspt-icon a-fx-none">
            <use xlink:href="#adspt-info-circle"></use>
        </svg>

        <div class="caption-1">
            {{ message | translatePart: 0 }}
            <a
                [routerLink]="invoicesTabUrl$ | async"
                queryParamsHandling="merge"
                adsptHeap="subscription-confirmation-invoices"
                >{{ message | translatePart: 1 }}</a
            >{{ message | translatePart: 2 }}
        </div>
    </div>
</div>
